import Vue from "vue";

const ErrorService = {
  store: null,
  init(opts) {
    if (opts.store) {
      this.store = opts.store;
    }
  },
  hasValidations(apiError) {
    if (!this.isApiErrorObject(apiError)) return null;
    return apiError.validationErrors && apiError.validationErrors.length > 0;
  },
  getValidationError(apiError, key) {
    if (!this.isApiErrorObject(apiError)) return null;
    if (!apiError.validationErrors) return null;
    return apiError.validationErrors[key];
  },
  clearValidationError(apiError, key) {
    if (!this.isApiErrorObject(apiError)) return null;
    Vue.delete(apiError.validationErrors, key);
  },
  clearAllValidationErrors(apiError) {
    if (!this.isApiErrorObject(apiError)) return null;
    Vue.set(apiError, "validationErrors", {});
  },
  clearAllErrors(apiError) {
    if (!this.isApiErrorObject(apiError)) return null;
    Vue.set(apiError, "validationErrors", {});
    Vue.set(apiError, "message", null);
  },
  addValidationError(apiError, key, value) {
    if (!this.isApiErrorObject(apiError)) return null;
    if (!apiError.validationErrors) return null;
    apiError.validationErrors[key] = value;
  },
  isApiErrorObject(object) {
    if (!object) return false;
    if (!(typeof object === "object")) return false;
    if (Object.keys(object) == 0) return false;
    return true;
  },
  formatFieldName(property) {
    if (!property) return "";
    property = property.trim();
    property = property.replace(/_/g, " ");
    property = property.replace(/([a-z])([A-Z])/g, "$1 $2");
    property = property.replace(/\s+/g, " ");

    return property
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
};
export default ErrorService;
